import script from "./MovieItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./MovieItem.vue?vue&type=script&lang=ts&setup=true"

import "./MovieItem.vue?vue&type=style&index=0&id=967c101c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-967c101c"]])

export default __exports__